{
  "pt": {
    "dashboard": {
      "greetings": {
        "afternoon": "Boa tarde {first_name}",
        "evening": "Boa noite {first_name}",
        "morning": "Bom dia {first_name}",
        "night": "Boa noite {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "Não tem itens pendentes de momento.",
        "caught_up_title": "Está tudo em dia",
        "completed_count": "{count} concluído(s)",
        "due_before": "Antes de {date}",
        "journey_no_active_subtitle": "Esta unidade ainda não iniciou o seu percurso.",
        "journey_no_active_title": "Nenhum marco ativo",
        "journey_select_unit_subtitle": "Escolha uma unidade acima para ver o seu percurso.",
        "journey_select_unit_title": "Selecione uma unidade",
        "journey_title": "O seu percurso",
        "open_action": "Abrir",
        "previous_label": "Marcos anteriores",
        "progress_completed": "{completed} / {total} concluído(s)",
        "show_less": "Mostrar menos",
        "show_more_tasks": "Mostrar mais {count} tarefa | Mostrar mais {count} tarefas",
        "status_active": "Em curso",
        "status_completed": "Concluído",
        "status_planned": "Planeado",
        "todo_now_title": "O que fazer agora",
        "upcoming_more": "Mais {count} marcos futuros"
      },
      "titles": {
        "activityFeed": "Feed de actividades",
        "assignedTasks": "As minhas tarefas",
        "newsFeed": "Feed de notícias",
        "ongoingTickets": "Em curso",
        "openTickets": "Aberto",
        "progress": "Progresso",
        "tickets": "Conversas",
        "totalTickets": "Todas as conversas",
        "unreadTickets": "Não lido",
        "yourAssignedTickets": "Atribuídas a si"
      }
    }
  }
}
